import "./Dropdown.scss";
import DropdownWithForm, { DropdownWithFormProps } from "./DropdownWithForm";
import DropdownWithoutForm, { DropdownWithoutFormProps } from "./DropdownWithoutForm";

type DropdownProps = Omit<
  DropdownWithoutFormProps &
    DropdownWithFormProps & {
      useHookForm?: boolean;
    },
  "onBlur"
>;

function Dropdown(props: DropdownProps) {
  const { useHookForm } = props;

  return useHookForm ? <DropdownWithForm {...props} /> : <DropdownWithoutForm {...props} />;
}

Dropdown.defaultProps = {
  customSelected: "",
};

export default Dropdown;

Dropdown.defaultProps = {
  useHookForm: false,
};
